import {
  ColDef,
  ICellRendererParams,
  ValueFormatterParams,
} from '@ag-grid-community/core'
import { InputOptions } from 'types/input'
import { formatDate } from 'utils/helpers'

export const FILTER_FIELD_NEW_SAP_BARCODE = 'newSapBarcodeFilters'

// Seen / Unseen filter. `NONE` clears the filter (handled by useLogFilters);
// the other values are sent to the server verbatim as `isSeen=true|false`.
export const SEEN_OPTIONS: InputOptions[] = [
  { label: '--- NONE ---', value: 'NONE' },
  { label: 'Seen', value: 'true' },
  { label: 'Unseen', value: 'false' },
]

const baseColumns: ColDef[] = [
  {
    headerName: 'Barcode',
    field: 'barcode',
    minWidth: 160,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    // Snapshot of the description SAP sent when the barcode first arrived.
    headerName: 'Description',
    field: 'description',
    minWidth: 260,
    flex: 1,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: 'Status',
    field: 'isSeen',
    minWidth: 120,
    cellRenderer: (params: ICellRendererParams) => {
      const isSeen: boolean = params.value
      return (
        <span
          className={`rounded-lg px-2 py-1 text-sm ${
            isSeen ? 'bg-green-400 text-black' : 'bg-gray-200 text-gray-700'
          }`}
        >
          {isSeen ? 'Seen' : 'Unseen'}
        </span>
      )
    },
  },
  {
    headerName: 'Synced At',
    field: 'createdAt',
    minWidth: 180,
    valueFormatter: (params: ValueFormatterParams) =>
      params.value ? formatDate(params.value, { includeTime: true }) : '-',
  },
]

// Leading checkbox column for the bulk "mark as read" action. Only unseen rows
// are selectable (seen ones show a disabled checkbox); the header checkbox
// selects every unseen row on the current page.
const selectionColumn: ColDef = {
  colId: 'select',
  headerName: '',
  maxWidth: 56,
  minWidth: 56,
  pinned: 'left',
  sortable: false,
  checkboxSelection: true,
  headerCheckboxSelection: true,
  headerCheckboxSelectionFilteredOnly: true,
  showDisabledCheckboxes: true,
}

// Editors get the selection column prepended so they can bulk mark rows as read;
// view-only users see the plain listing.
export const getColumns = (isEditor: boolean): ColDef[] =>
  isEditor ? [selectionColumn, ...baseColumns] : baseColumns
